<h2>{{ "CASE_FORM.FORMS.BANK_ACCOUNT.TITLE" | translate }}</h2>
<form
  data-testid="bank-account-form"
  [formGroup]="form"
  [class.valid]="form.valid"
>
  <div class="top-margin-15">
    <payee-form-field
      width="max"
      height="tall"
    >
      <input
        payee-input
        data-testid="bank-account-number"
        formControlName="account_number"
        [placeholder]="'CASE_FORM.FORMS.BANK_ACCOUNT.ACCOUNT_NUMBER_PLACEHOLDER' | translate"
      />
      @if (account_number.invalid && account_number.dirty) {
        <ng-container payee-error>
          @if (account_number.hasError("required")) {
            <span>
              {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
            </span>
          }
          @if (account_number.hasError("pattern")) {
            <span>
              {{
                "ERROR_MESSAGES.INVALID_FORMAT_WITH_EXAMPLE"
                  | translate
                    : {
                        pattern: "HU39162001511856250100000000",
                      }
              }}
            </span>
          }
          @if (account_number.hasError("unknown")) {
            <span>
              {{ account_number.errors?.unknown }}
            </span>
          }
        </ng-container>
      }
    </payee-form-field>
  </div>

  <!-- <div class="top-margin-15">
<payee-form-field width="max" height="tall">
  <input
    payee-input
    formControlName="bic"
    [placeholder]="'CASE_FORM.FORMS.BANK_ACCOUNT.BIC_PLACEHOLDER' | translate"
    />
  @if (bic.invalid && bic.dirty) {
    <ng-container payee-error>
      @if (bic.hasError('required')) {
        <span>
          {{ 'ERROR_MESSAGES.FIELD_REQUIRED' | translate }}
        </span>
      }
      @if (bic.hasError('unknown')) {
        <span>
          {{ bic.errors.unknown }}
        </span>
      }
    </ng-container>
  }
</payee-form-field>
</div> -->
</form>
